// extracted by mini-css-extract-plugin
export default {"walletHistoryItemContainer":"style_walletHistoryItemContainer__2Vpte","result":"style_result__JRb9J"};